module.exports = __webpack_public_path__ + "f591c35647388fa57aa6c1a05c0c564c.svg";